import { IChangeIdentification } from '../../models';

export interface IChangeIdentificationFormDefaultValues {
  changeIdentification_country: string | null;
  changeIdentification_vatNum: string | null;
}

export function handleChangeIdentificationDefaultValues(
  change_identification: IChangeIdentification
): IChangeIdentificationFormDefaultValues {
  return {
    changeIdentification_country:
      change_identification && change_identification.country_id
        ? `${change_identification.country_id}`
        : null,
    changeIdentification_vatNum:
      change_identification && change_identification.vat_id_num
        ? change_identification.vat_id_num
        : null,
  };
}
